module.exports = __webpack_public_path__ + "static/desktop/img/shelf.8e76717f.svg";